import AppLinkComponent, { AppLinkProps } from "@/components/AppLink";
import ButtonComponent, { ButtonProps } from "@/components/Button";
import { SVGArrowRight as SVGArrowRightComponent } from "@/lib/svg";
import { Wrapper } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const AppLink = AppLinkComponent as any;
const Button = ButtonComponent as any;
const SVGArrowRight = SVGArrowRightComponent as any;

type InternalLink = AppLinkProps & {
  _type: "internalLink";
  title: string | null;
};

type ExternalLink = {
  _type: "externalLink";
  title: string | null;
  url: string | null;
  blank: boolean;
};

export type CallToActionProps = InternalLink | ExternalLink;

const CallToAction: React.FC<CallToActionProps> = (props) => {
  const { _type, title } = props;
  if (!title) return null;

  const buttonProps: ButtonProps = {
    as: "a",
    variant: "primaryUnboxed",
    icon: <SVGArrowRight />,
    children: title,
  };

  if (_type === "internalLink" && props.page) {
    return (
      <Wrapper>
        <AppLink page={props.page} params={props.params}>
          <Button {...buttonProps} />
        </AppLink>
      </Wrapper>
    );
  } else if (_type === "externalLink" && props.url) {
    return (
      <Wrapper>
        <Button
          {...buttonProps}
          href={props.url}
          target={`${props.blank ? "_blank" : ""}`}
        />
      </Wrapper>
    );
  }
  return null;
};

export default CallToAction;
